import * as NoteTranscriptSegment from '../models/note/transcriptSegment';

import { Common } from '../common';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(
    values: NoteTranscriptSegment.BaseValues,
  ): Promise<NoteTranscriptSegment.NoteTranscriptSegment> {
    const url = this.common.constructPath(`/note-transcript-segments`);
    return this.common.postJSON(url, values);
  }

  async update(
    id: string,
    values: NoteTranscriptSegment.UpdateValues,
  ): Promise<NoteTranscriptSegment.NoteTranscriptSegment> {
    const url = this.common.constructPath(`/note-transcript-segments/${id}`);
    return this.common.patchJSON(url, values);
  }

  async upsert(
    values: NoteTranscriptSegment.BaseValues,
  ): Promise<NoteTranscriptSegment.NoteTranscriptSegment> {
    const url = this.common.constructPath(`/note-transcript-segments`);
    return this.common.putJSON(url, values);
  }
}
